<template>
  <div class="appointment_item">
    <app-record
      :record="appointment.record"
      tooltip-position="is-left"
      hide-extra-icons
    />

    <div class="appointment_item--info">
      <p>{{ startAt }} to {{ endAt }}</p>
      <p v-if="showLocation">@ {{ appointment.location }}</p>
    </div>
  </div>
</template>

<script>
import dates from "../../../services/dates";

export default {
  name: "UserDashboardAppointmentItem",
  props: {
    appointment: {
      type: Object,
      required: true,
    },
  },
  computed: {
    showLocation() {
      const location = this.appointment.location
      const line_1 = this.appointment.record.property.line_1

      if(location) {
        return !location.includes(line_1);
      } else {
        return false;
      }
    },
    startAt() {
      return dates.formatAsTime(this.appointment.start_at)
    },
    endAt() {
      return dates.formatAsTime(this.appointment.end_at)
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

.appointment_item {
  padding: 14px;
  border-bottom: 1px solid $border;

  &--info {
    font-size: 0.875rem;
    line-height: 1.3;
  }
}
</style>
